import styled from 'styled-components'

import {
  _M_Medium,
  _XL_Bold,
  mainColors,
  medias,
  rgba,
  shadowColors,
  zIndex,
} from '@avantstay/backoffice-core'
import { IconChevronLeft } from '@avantstay/backoffice-vectors'

export const MainContainer = styled.div`
  position: fixed;
  z-index: ${zIndex.MODAL};
  top: 0;
  left: 15px;
  overflow: inherit;
  width: 100%;
  height: 100%;
  background: ${mainColors.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: ${zIndex.FILTERS};

  animation: translate 0.2s forwards;

  @keyframes translate {
    100% {
      left: 0;
    }
  }

  ${medias.LG_SCREEN`
    position: relative;
    left: 0;
    width: 222px;
    border: 1px solid ${mainColors.neutralLight};
    border-radius: 2px;
    box-shadow: 0px 4px 16px ${rgba(shadowColors.blur, 0.4)};

    button {
      min-height: 16px;
    }
  `}
`

// Widget Content
export const Header = styled.div<{ reducePadding?: boolean }>`
  flex-direction: column;
  display: flex;
  padding: 30px 16px 20px;
  background-color: ${mainColors.neutralLight};
  min-height: 90px;
  gap: 30px;
  ${_M_Medium};

  svg {
    width: 30px;
    height: 30px;
    color: ${mainColors.neutralDark};
    margin-left: -8px;
  }
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const ActionsRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ExitButton = styled(IconChevronLeft)`
  position: absolute;
  top: 0;
  left: 10px;
`

export const Title = styled.span`
  ${_XL_Bold};
  color: ${mainColors.black};
`

export const ChildrenContainer = styled.div`
  flex: 2;

  overflow: auto;

  > * {
    position: relative;

    padding-bottom: 10px;

    &:not(:last-child) {
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: ${mainColors.neutralMedium};
        width: 100%;
        height: 1px;
      }
    }

    ${medias.LG_SCREEN`
    margin-top: 14px;
    margin-bottom: 10px;

      &:not(:last-child) {
        margin-bottom: 16px;
        &::after {
       display: none;
      }
    }`}
  }

  * {
    font-size: 16px !important;
  }
`

export const Footer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 10px 16px 0;
  /* Safari ios */
  margin-bottom: 10px;
  border-top: 1px solid ${mainColors.neutralLight};
  max-height: 47px;

  > * {
    width: calc(50% - 4px);
  }

  ${medias.LG_SCREEN`
    padding: 0 16px;
    margin-bottom: 16px;
    border-color: transparent;
  `}

  button {
    padding: 10px 14px;
  }
`
